// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"190":"component/chapter","704":"component/book","820":"component/task","834":"component/page"}[chunkId] + "." + {"190":"d96201fa","704":"80106629","820":"449c6807","834":"d480677b"}[chunkId] + ".js";
};